import { Fragment, useState, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import {
  CheckIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { classNames } from "../../utils/helperFuctions";
import ReusableForm from "../ReusableForm/ReusableForm";
import { ClipLoader } from "react-spinners";
import ProgressBar from "../Progress/ProgressBar";

export default function PopUp({
  isError,
  title,
  description,
  formOptions,
  takeActionText,
  takeActionFun,
  takeActionText2,
  takeActionFun2,
  showPopUp,
  hidePopUp,
  formSubmit,
  formConcatData,
  propName,
  disabledForm,
  children,
  width,
  hideCancel,
  hideMainButton,
  showLoading,
  progressValue,
  overflow,
  expand,
  resetPopUp,
  actionType,
}) {
  const _overflow = overflow || true;
  const panelRef = useRef(null);

  if (!showPopUp || !(title || description || formOptions || children)) {
    return null;
  }

  const actionClicked = () => {
    if (hidePopUp != null) {
      hidePopUp();
    } else if (resetPopUp != null) {
      resetPopUp();
    } else {
    }
    if (takeActionFun instanceof Function) {
      takeActionFun();
    }
  };
  const actionClicked2 = () => {
    if (hidePopUp != null) {
      hidePopUp();
    } else if (resetPopUp != null) {
      resetPopUp();
    } else {
    }
    if (takeActionFun2 instanceof Function) {
      takeActionFun2();
    }
  };
  const dialogClosed = () => {};
  const handleSubmit = (data, hasFiles) => {
    if (formSubmit instanceof Function) {
      formSubmit(data, hasFiles, formConcatData, propName);
    }
  };

  return (
    <Transition.Root
      show={
        showPopUp && (title || description || formOptions || children)
          ? true
          : false
      }
      as={Fragment}
    >
      <Dialog as="div" className="relative z-50" onClose={dialogClosed}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-[20ms]"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div
            className={`flex min-h-full h-full justify-center p-4 text-center sm:items-center sm:p-0 items-center sm:py-8`}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                id="popupPanel"
                className={` flex flex-col relative transform max-h-full overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:max-w-fit sm:w-fit sm:p-6 ${
                  width ? width : "sm:min-w-[300px] "
                }`}
              >
                <div
                  onClick={() => {
                    if (hidePopUp != null) {
                      hidePopUp();
                    } else if (resetPopUp != null) {
                      resetPopUp();
                    } else {
                    }
                  }}
                  className={classNames(
                    formOptions ? "" : "hidden",
                    "absolute top-3 right-3 w-5 cursor-pointer hover:scale-125"
                  )}
                >
                  <div className="bg-primary rounded-full p-1 text-white hover:bg-blue-600 transition-colors">
                    <XMarkIcon className="h-4 w-4" />
                  </div>
                </div>
                {/* <div
                  className={classNames(
                    isError === true
                      ? "bg-green-100"
                      : isError === false
                      ? "bg-red-100"
                      : "hidden",
                    "mx-auto flex h-12 w-12 items-center justify-center rounded-full"
                  )}
                >
                  {isError === true ? (
                    <ExclamationTriangleIcon
                      className="h-6 w-6 text-red-600"
                      aria-hidden="true"
                    />
                  ) : isError === false ? (
                    <CheckIcon
                      className="h-6 w-6 text-green-600"
                      aria-hidden="true"
                    />
                  ) : null}
                </div> */}
                <div
                  className={`${
                    isError !== undefined ? "mt-3 sm:mt-5" : ""
                  } text-center`}
                >
                  {showLoading && (
                    <ClipLoader color="#0167ff" className="mt-2" />
                  )}
                  <Dialog.Title
                    as="h3"
                    className="text-base font-semibold leading-6 text-gray-900"
                  >
                    {title}
                  </Dialog.Title>
                  {description && (
                    <div className="mt-2">
                      <div className="text-sm text-gray-500">{description}</div>
                    </div>
                  )}

                  {!isNaN(parseInt(progressValue)) && (
                    <ProgressBar className="mt-2" value={progressValue} />
                  )}
                </div>

                {/* removed overflow-auto */}
                <div
                  className={`${
                    expand === true ? "min-h-[400px]" : ""
                  } overflow-auto`}
                  ref={panelRef}
                >
                  <div className="text-center">
                    {formOptions && (
                      <div className="mt-2">
                        {formOptions && (
                          <ReusableForm
                            actionType={actionType}
                            fields={formOptions}
                            onSubmit={handleSubmit}
                            onCancel={actionClicked}
                            disabled={disabledForm}
                            id={formConcatData?.id}
                            hideCancel={true}
                            stickySubmitActions={true}
                            fromPopUp={true}
                          />
                        )}
                      </div>
                    )}

                    {children && (
                      <div className="mt-2 overflow-auto">{children}</div>
                    )}
                  </div>
                </div>
                {formOptions == null && (
                  <div
                    className={classNames(
                      "mt-5 sm:mt-6 gap-3",
                      (!title && !description) || formOptions ? "" : "",
                      hideCancel && !takeActionFun2
                        ? ""
                        : "sm:grid sm:grid-cols-2"
                    )}
                  >
                    {!hideCancel && (
                      <button
                        type="button"
                        className={classNames(
                          "inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
                          takeActionFun2
                            ? "sm:col-span-2 sm:row-start-2"
                            : "sm:col-start-1"
                        )}
                        onClick={() => {
                          hidePopUp?.();
                          resetPopUp?.();
                        }}
                      >
                        Cancel
                      </button>
                    )}

                    {/* Primary Action Button */}
                    <button
                      type="button"
                      className={classNames(
                        "inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
                        hideMainButton ? "hidden" : "",
                        takeActionFun2 ? "sm:col-start-1" : "sm:col-start-2"
                      )}
                      onClick={actionClicked}
                    >
                      {takeActionText ?? "Okay"}
                    </button>

                    {/* Secondary Action Button - only shown if exists */}
                    {takeActionFun2 && takeActionText2 && (
                      <button
                        type="button"
                        className={classNames(
                          "inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600",
                          hideMainButton ? "hidden" : "sm:col-start-2"
                        )}
                        onClick={actionClicked2}
                      >
                        {takeActionText2}
                      </button>
                    )}
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
